import { render, staticRenderFns } from "./PrkEditor.vue?vue&type=template&id=16a7ef49&scoped=true&"
import script from "./PrkEditor.vue?vue&type=script&lang=js&"
export * from "./PrkEditor.vue?vue&type=script&lang=js&"
import style0 from "./PrkEditor.vue?vue&type=style&index=0&id=16a7ef49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a7ef49",
  null
  
)

export default component.exports